import { makeStyles } from '@material-ui/core/styles';
// import Back from "../../imagens/bra_fundo_01.svg";

export const useStyles = makeStyles((theme) => ({
    dataGrid:{
        backgroundColor: theme.palette.grey[100],
        color: theme.palette.grey[400]
    }
}));